import { render, staticRenderFns } from "./EtsyTransferTableUser.vue?vue&type=template&id=618e0784&scoped=true"
import script from "./EtsyTransferTableUser.vue?vue&type=script&lang=js"
export * from "./EtsyTransferTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e0784",
  null
  
)

export default component.exports